/*
 * Copyright (c) 2024. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { type ComponentType, lazy as reactLazy } from 'react';

// this solution is a temporary patch to an issue with dynamically import modules
// using vite. this issue comes up in CI. this is a copy paste of a solution
// from a post on this vitejs github issue: https://github.com/vitejs/vite/issues/11804#issuecomment-1833547616

// biome-ignore lint/suspicious/noExplicitAny: could be any
function importErrorHandler(err: string): { default: ComponentType<any> } {
  // Get the last reload time from local storage and the current time
  const timeStr = sessionStorage.getItem('last-reload');
  const time = timeStr ? Number(timeStr) : null;
  const now = Date.now();

  // If the last reload time is more than 10 seconds ago, reload the page
  const isReloading = !time || time + 10_000 < now;
  if (isReloading) {
    // biome-ignore lint/suspicious/noConsole: console log is ok here
    console.log('New version for this module found. Reloading ...');
    sessionStorage.setItem('last-reload', String(now));
    window.location.reload();
    // Return an empty module so we do not see the error in the app before reloading
    return { default: () => null };
  }

  // We let ErrorBoundary handle the error
  throw new Error(err);
}

// biome-ignore lint/suspicious/noExplicitAny: could be any
export const lazy = (factory: () => Promise<{ default: ComponentType<any> }>) =>
  reactLazy(() => factory().catch(importErrorHandler));
